import script from "./Auth2faModal.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth2faModal.vue?vue&type=script&setup=true&lang=js"

import "./Auth2faModal.vue?vue&type=style&index=0&id=28ce6bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ce6bea"]])

export default __exports__